import React, { forwardRef, memo } from 'react'
import { Control, Controller, DeepMap, FieldError } from 'react-hook-form'

// TODO: use NumberInputField, and add option for custom onChange handler
import { NumberInput } from '@surglogs-app/ui'

import { AccountEditPinFormData } from '../validators/accountEditPinFormValidator'

interface SettingsUserEditPinInputProps {
  errors?: DeepMap<AccountEditPinFormData, FieldError>
  control?: Control<AccountEditPinFormData>
  name?: string
  index?: number
  onChange?: (value: string) => void
}

export const SettingsUserEditPinInput = memo(
  forwardRef<HTMLInputElement, SettingsUserEditPinInputProps>(
    ({ errors, control, name, index, ...rest }, ref) => {
      const fieldName = `${name}-${index}` as keyof AccountEditPinFormData

      return (
        <Controller<AccountEditPinFormData>
          {...{
            control,
            name: fieldName,
            render: ({ field }) => (
              <NumberInput
                {...{
                  precision: 1,
                  scale: 1,
                  maxLength: 1,
                  'aria-label': 'pin-input',
                  ...field,
                  ...rest,
                  onChange: (e) => {
                    field?.onChange(e)
                    rest?.onChange?.(e)
                  },
                  invalid:
                    errors &&
                    !!errors[fieldName as keyof AccountEditPinFormData],
                  ref,
                }}
              />
            ),
          }}
        />
      )
    },
  ),
)
